import React from 'react'
import { useSelector } from 'react-redux'
import { Tooltip, Typography, Box } from '@mui/material'
import { getObjectCurriculumElementsDR } from '../../../../Assessment/utils'
import TextEllipsis from '../../../../../text/TextEllipsis'
import TextNotAssigned from '../../../../../text/TextNotAssigned'

const ButtonItemClass = ({ data, isSelected }) => {
  const years = useSelector((state) => state?.tenant?.years || [])
  const currentCurriculum = useSelector(
    (state) => state?.assessment?.curriculum.find((x) => x._id === data.curriculumId) || {}
  )
  const curriculumElements = getObjectCurriculumElementsDR(
    currentCurriculum?.elements,
    currentCurriculum?.elementsStructure,
    data?.curriculumElements || {}
  )

  return (
    <button
      className={[
        'border border-primary  rounded  text-sm text-nowrap cursor-pointer flex  ',
        isSelected ? 'bg-primary text-primary-foreground' : 'bg-white text-primary'
      ].join(' ')}
    >
      <div className='flex flex-col items-start gap-1 py-1 px-2 max-w-120px bg-loading  '>
        <Typography noWrap className='font-bold text-xl'>
          {data?.code}
        </Typography>
        <Typography noWrap className='text-sm text-gray-500'>
          {years
            .filter((year) => data.yearLevel.includes(year._id))
            .map((year) => year.name)
            .join(', ') || 'N/A'}
        </Typography>
      </div>
      <Box
        className='flex flex-col items-start gap-1 py-1 px-2 max-w-100px  '
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.04)'
        }}
      >
        <Typography noWrap className='font-bold uppercase text-2xs'>
          teachers
        </Typography>
        {data?.teachers?.map((t) => (
          <Tooltip arrow title={`${t.code} - ${t.firstName} ${t.lastName}`} key={`key-teacher-${t._id}`}>
            <div className='text-xs bg-primary-foreground text-primary px-1  opacity-90 rounded cursor-pointer'>
              {t.lastName}
            </div>
          </Tooltip>
        ))}
      </Box>
      <Box className=' px-2 py-1 max-w-150px '>
        <div className='flex gap-1 items-center '>
          <span className='text-sm font-bold text-nowrap'>{curriculumElements?.element?.keyName}</span>
          <TextEllipsis className='text-sm'>
            {curriculumElements?.element?.valueName || <TextNotAssigned />}
          </TextEllipsis>
        </div>
        {curriculumElements?.subElement?.keyName && (
          <div className='flex gap-1 items-center'>
            <span className='text-sm font-bold text-nowrap'>{curriculumElements?.subElement?.keyName}</span>
            <TextEllipsis className='text-sm'>
              {curriculumElements?.subElement?.valueName || <TextNotAssigned />}
            </TextEllipsis>
          </div>
        )}
        {data?.subjectId?.name && (
          <div className='flex gap-1 items-center mt-2'>
            <span className='text-sm font-bold text-nowrap'>Subject</span>
            <TextEllipsis className='text-sm'>{data?.subjectId?.name || <TextNotAssigned />}</TextEllipsis>
          </div>
        )}
      </Box>
    </button>
  )
}

export default ButtonItemClass
